(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/charts-loader.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"chart-loader\"> <div class=\"d-flex align-items-start justify-content-around animated-background\"> <div class=\"shape-v shape0\"></div> <div class=\"shape-v shape1\"></div> <div class=\"shape-v shape2\"></div> <div class=\"shape-v shape3\"></div> <div class=\"shape-v shape4\"></div> <div class=\"shape-v shape5\"></div> <div class=\"shape-v shape6\"></div> <div class=\"shape-v shape7\"></div> <div class=\"shape-v shape8\"></div> <div class=\"shape-v shape9\"></div> <div class=\"shape-v shape10\"></div> </div> </div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
